import CallCenterImportRegister from "pages/LandingPages/CallCenter";

export default function CallCenterImportRegisterPage() {
  return <CallCenterImportRegister />;
}
